import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import PanelHeader from './components/PanelHeader';
import { ConfirmProvider } from '../context/ConfirmContext';
import { InstagramAccountProvider } from '../context/InstagramAccountContext';

export default function PanelLayout() {
  return (
    <InstagramAccountProvider>
      <ConfirmProvider>
        <div className="min-h-screen flex flex-col bg-[#faf6f0] dark:bg-lc-bg text-[#241c14] dark:text-lc-text">
          <PanelHeader />
          <div className="flex flex-1 min-h-0">
            <Sidebar />
            <main className="flex-1 min-w-0 overflow-y-auto bg-[#faf6f0] dark:bg-lc-bg">
              <div className="p-6 sm:p-8 max-w-[1400px] w-full">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </ConfirmProvider>
    </InstagramAccountProvider>
  );
}
